module.exports = __webpack_public_path__ + "img/1368Logo.4cc18bf5.png";